import ButtonToggleFavorite from './ButtonToggleFavorite'

export default ButtonToggleFavorite
